import { useEffect, useState } from 'react'
import { supabase } from '../../../lib/supabase'
import AdminLayout from '../components/AdminLayout'
import CampaignsTable from './components/CampaignsTable'
import CampaignForm from './components/CampaignForm'
import LoadingSpinner from '../../../components/LoadingSpinner'

export default function AdminWelfare() {
  const [campaigns, setCampaigns] = useState([])
  const [loading, setLoading] = useState(true)
  const [showForm, setShowForm] = useState(false)
  const [editing, setEditing] = useState(null)

  const fetchCampaigns = async () => {
    const { data } = await supabase
      .from('welfare_campaigns').select('*')
      .eq('club_id', 'a0000000-0000-0000-0000-000000000001')
      .order('created_at', { ascending: false })
    if (data) setCampaigns(data)
    setLoading(false)
  }

  useEffect(() => { fetchCampaigns() }, [])

  return (
    <AdminLayout>
      <div className="mb-6 lg:mb-8 flex justify-between items-center gap-4">
        <div>
          <h1 className="text-2xl lg:text-4xl font-black uppercase tracking-tight mb-2 text-gray-900 dark:text-white">
            Welfare
          </h1>
          <p className="text-gray-500 text-sm">{campaigns.length} campaigns total</p>
        </div>
        <button
          onClick={() => { setEditing(null); setShowForm(true) }}
          className="bg-green-600 hover:bg-green-700 text-white px-4 sm:px-6 py-3 font-bold uppercase tracking-widest text-xs sm:text-sm transition-colors whitespace-nowrap"
        >
          New Campaign
        </button>
      </div>

      {loading ? (
        <LoadingSpinner fullScreen message="Loading campaigns..." />
      ) : (
        <CampaignsTable
          campaigns={campaigns}
          onEdit={(campaign) => { setEditing(campaign); setShowForm(true) }}
          onRefresh={fetchCampaigns}
        />
      )}

      {showForm && (
        <CampaignForm
          campaign={editing}
          onClose={() => { setShowForm(false); setEditing(null) }}
          onRefresh={fetchCampaigns}
        />
      )}
    </AdminLayout>
  )
}